import { useStorageState } from 'react-storage-hooks';

import { CONSTANTS } from '../../../../../../core/config/constants';
import { BenchmarkView } from '../../../../../../generated/model/benchmarkView';

interface ConsolidationToggleStorage {
  toggleValue: BenchmarkView.ConsolidationPreferenceEnum;
  version: string;
}

const version = CONSTANTS.CONSOLIDATION_TOGGLE_STORAGE.VERSION;

export const useConsolidationToggleStorage = () => {
  const [toggleStorage, setToggleStorage] = useStorageState<ConsolidationToggleStorage>(
    // don't change sessionStorage to localStorage
    // it's causes browser freezes due to multiple subscribers to the shared storage
    sessionStorage,
    CONSTANTS.CONSOLIDATION_TOGGLE_STORAGE.KEY,
    { toggleValue: 'CONSOLIDATED', version: CONSTANTS.CONSOLIDATION_TOGGLE_STORAGE.VERSION },
  );
  const onToggleChange = (consolidated: BenchmarkView.ConsolidationPreferenceEnum) => {
    setToggleStorage({ toggleValue: consolidated, version });
  };

  return { toggleValue: toggleStorage.toggleValue, onToggleChange: onToggleChange };
};
